import { getLinkTarget } from '@anm/helpers/upgradeLink';
import noop from 'lodash/fp/noop';

import vtConfig from '../../../../config';

const { urls } = vtConfig();

export default (canOpen: boolean, projectId?: string, onCanNotOpen = noop) => {
  const editorUrl = `${urls.editor}/#p=${projectId}`;

  const canNotOpenHandler = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault();
    onCanNotOpen();
  };

  const renderEditLink = (children: JSX.Element) =>
    projectId && canOpen ? (
      <a href={editorUrl} data-button="edit link" target={getLinkTarget()}>
        {children}
      </a>
    ) : (
      <a onClick={canNotOpenHandler}>{children}</a>
    );

  return renderEditLink;
};
